import { gql } from '@apollo/client';
import List from './List';
import Edit from './Edit';
import Show from './Show';

export default {
  name: 'permanent_requests',
  inputShow: gql`
    query permanentRequests($input: AssignmentRequestQueryInput) {
      permanentRequests(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Permanent Requests',
  },
};
